import { useSelector } from '@/redux'

export function useMerchant () {
  return useSelector(state => state.merchant.data)
}

export default {
  useMerchant,
}
